import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { colorsFoundation } from "../../../theme/index.js";

/**
 * "Ihre Daten prüfen" — a read-only summary card of the customer's master data at
 * the top of the schmidt customer phase. The editable contact fields
 * (ansprechpartner_*) are rendered as normal fields in the same step below it.
 */
export default function ClaimMasterDataCard({ model = {}, values = {} }) {
  const user = model.user || {};
  const name =
    [user.vorname, user.nachname].filter(Boolean).join(" ") ||
    [values.ansprechpartner_vorname, values.ansprechpartner_name]
      .filter(Boolean)
      .join(" ") ||
    "–";

  const rows = [
    ["Name", name],
    ["Telefon", user.telefon || values.ansprechpartner_telefon || "–"],
    ["E-Mail", user.email || values.ansprechpartner_email || "–"],
    ["Vertrag", values.vertragsnummer || model.vertragsnummer || "–"],
  ];

  return (
    <Box
      sx={{
        border: `1px solid ${colorsFoundation.gray[200]}`,
        borderRadius: "12px",
        p: "16px 18px",
        backgroundColor: colorsFoundation.gray[50],
        width: "100%",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "14px 22px",
      }}
    >
      {rows.map(([label, value]) => (
        <Box key={label}>
          <Typography
            sx={{ fontSize: "11px", color: colorsFoundation.gray[500], mb: "3px" }}
          >
            {label}
          </Typography>
          <Typography
            sx={{
              fontSize: "13.5px",
              fontWeight: 600,
              color: colorsFoundation.gray[900],
            }}
          >
            {value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

ClaimMasterDataCard.propTypes = {
  model: PropTypes.object,
  values: PropTypes.object,
};
